import React, { useMemo, useState } from 'react';
import { parseISO, compareDesc } from 'date-fns';

import { Button, Icon } from '@iq/react-components';
import {
  formatBytes,
  getFilenameWithoutExt as getFilenameWithoutExtension,
} from '../../../../../utils';
import FiletypeIcon from '../../../../FiletypeIcon';
import Pill from '../../../../Pill';
import FileListBookmarks from '../FileListBookmarks';
import { DropdownMenu } from '../../../../DropdownMenu';

const hideFileExtension = (filename) => getFilenameWithoutExtension(filename) || filename;

const FileList = ({
  files,
  onPreview,
  filterValue,
  tagFilter,
  activeComponentId,
  onSelectFile,
  disableSelect,
  getDropdownOptions = () => [],
  showFileExtension = true,
}) => {
  const sorted = useMemo(
    () =>
      files.toSorted(({ createdAt: a }, { createdAt: b }) => compareDesc(parseISO(a), parseISO(b))),
    [files]
  );
  const [visibleBookmarkLists, setVisibleBookmarkLists] = useState([]);

  const onToggleBookmarkList = (fileId) => {
    setVisibleBookmarkLists(() =>
      visibleBookmarkLists.includes(fileId)
        ? visibleBookmarkLists.filter((id) => id !== fileId)
        : [...visibleBookmarkLists, fileId]
    );
  };

  return (
    <div className="file-list-component">
      {sorted.map((file, index) => (
        <React.Fragment key={index}>
          <div className="file-component">
            {!disableSelect && (
              <div className="select-box">
                <Button
                  design="text"
                  tooltip="Select"
                >
                  <Icon
                    className={`checkbox ${file.isSelected ? 'checked' : ''}`}
                    icon={`${file.isSelected ? 'he-checkbox-selected' : 'he-checkbox'}`}
                    size="s"
                    onClick={(event) => {
                      event.stopPropagation();
                      onSelectFile(file);
                    }}
                  />
                </Button>
              </div>
            )}
            <div className="filetype">{<FiletypeIcon file={file} />}</div>
            <div className="file-info">
              <div
                className="filename"
                onClick={() => onPreview(file)}
              >
                {showFileExtension ? file.filename : hideFileExtension(file.filename)}
              </div>
              <div className="file-extras-wrapper">
                {file.bookmarks.length > 0 && (
                  <div className="file-pill">
                    <Pill
                      icon="bookmark"
                      text={file.bookmarks.length}
                      onClick={() => onToggleBookmarkList(file.id)}
                    />
                  </div>
                )}
                <div className="filesize">{formatBytes(file.size)}</div>
              </div>
            </div>
            {getDropdownOptions(file).length > 0 && (
              <DropdownMenu
                trigger="he-moreoptionsvertical"
                menuOptions={getDropdownOptions(file)}
                menuXPlacement="left"
                styles={{
                  dropdownIndicator: { padding: 'calc(0.15rem + 2.5px)' },
                }}
              />
            )}
          </div>
          <FileListBookmarks
            onPreview={onPreview}
            file={file}
            filterValue={filterValue}
            bookmarks={file.bookmarks}
            tagFilter={tagFilter}
            activeComponentId={activeComponentId}
            bookmarkListToggled={visibleBookmarkLists.includes(file.id)}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default FileList;
